// Generated from /Users/niket/Developer/0.0.TestProjects/4.0.Antlr/FiltersV1/src/Filters.g4 by ANTLR 4.7
// jshint ignore: start
var antlr4 = require('antlr4/index');

// This class defines a complete listener for a parse tree produced by FiltersParser.
function FiltersListener() {
  antlr4.tree.ParseTreeListener.call(this);
  return this;
}

FiltersListener.prototype = Object.create(antlr4.tree.ParseTreeListener.prototype);
FiltersListener.prototype.constructor = FiltersListener;

// Enter a parse tree produced by FiltersParser#filters.
FiltersListener.prototype.enterFilters = function (ctx) {};

// Exit a parse tree produced by FiltersParser#filters.
FiltersListener.prototype.exitFilters = function (ctx) {};

// Enter a parse tree produced by FiltersParser#bracketnotation.
FiltersListener.prototype.enterBracketnotation = function (ctx) {};

// Exit a parse tree produced by FiltersParser#bracketnotation.
FiltersListener.prototype.exitBracketnotation = function (ctx) {};

// Enter a parse tree produced by FiltersParser#bracketnotation_expr.
FiltersListener.prototype.enterBracketnotation_expr = function (ctx) {};

// Exit a parse tree produced by FiltersParser#bracketnotation_expr.
FiltersListener.prototype.exitBracketnotation_expr = function (ctx) {};

// Enter a parse tree produced by FiltersParser#queryGroup.
FiltersListener.prototype.enterQueryGroup = function (ctx) {};

// Exit a parse tree produced by FiltersParser#queryGroup.
FiltersListener.prototype.exitQueryGroup = function (ctx) {};

// Enter a parse tree produced by FiltersParser#groupJoinOp.
FiltersListener.prototype.enterGroupJoinOp = function (ctx) {};

// Exit a parse tree produced by FiltersParser#groupJoinOp.
FiltersListener.prototype.exitGroupJoinOp = function (ctx) {};

// Enter a parse tree produced by FiltersParser#queryExpr.
FiltersListener.prototype.enterQueryExpr = function (ctx) {};

// Exit a parse tree produced by FiltersParser#queryExpr.
FiltersListener.prototype.exitQueryExpr = function (ctx) {};

// Enter a parse tree produced by FiltersParser#queryRule.
FiltersListener.prototype.enterQueryRule = function (ctx) {};

// Exit a parse tree produced by FiltersParser#queryRule.
FiltersListener.prototype.exitQueryRule = function (ctx) {};

// Enter a parse tree produced by FiltersParser#atom.
FiltersListener.prototype.enterAtom = function (ctx) {};

// Exit a parse tree produced by FiltersParser#atom.
FiltersListener.prototype.exitAtom = function (ctx) {};

// Enter a parse tree produced by FiltersParser#pathRef.
FiltersListener.prototype.enterPathRef = function (ctx) {};

// Exit a parse tree produced by FiltersParser#pathRef.
FiltersListener.prototype.exitPathRef = function (ctx) {};

// Enter a parse tree produced by FiltersParser#attrpart.
FiltersListener.prototype.enterAttrpart = function (ctx) {};

// Exit a parse tree produced by FiltersParser#attrpart.
FiltersListener.prototype.exitAttrpart = function (ctx) {};

// Enter a parse tree produced by FiltersParser#regexBegin.
FiltersListener.prototype.enterRegexBegin = function (ctx) {};

// Exit a parse tree produced by FiltersParser#regexBegin.
FiltersListener.prototype.exitRegexBegin = function (ctx) {};

// Enter a parse tree produced by FiltersParser#regexContains.
FiltersListener.prototype.enterRegexContains = function (ctx) {};

// Exit a parse tree produced by FiltersParser#regexContains.
FiltersListener.prototype.exitRegexContains = function (ctx) {};

// Enter a parse tree produced by FiltersParser#regexEnd.
FiltersListener.prototype.enterRegexEnd = function (ctx) {};

// Exit a parse tree produced by FiltersParser#regexEnd.
FiltersListener.prototype.exitRegexEnd = function (ctx) {};

// Enter a parse tree produced by FiltersParser#joinOp.
FiltersListener.prototype.enterJoinOp = function (ctx) {};

// Exit a parse tree produced by FiltersParser#joinOp.
FiltersListener.prototype.exitJoinOp = function (ctx) {};

// Enter a parse tree produced by FiltersParser#caseParam.
FiltersListener.prototype.enterCaseParam = function (ctx) {};

// Exit a parse tree produced by FiltersParser#caseParam.
FiltersListener.prototype.exitCaseParam = function (ctx) {};

// Enter a parse tree produced by FiltersParser#filterOp.
FiltersListener.prototype.enterFilterOp = function (ctx) {};

// Exit a parse tree produced by FiltersParser#filterOp.
FiltersListener.prototype.exitFilterOp = function (ctx) {};

// Enter a parse tree produced by FiltersParser#nullValue.
FiltersListener.prototype.enterNullValue = function (ctx) {};

// Exit a parse tree produced by FiltersParser#nullValue.
FiltersListener.prototype.exitNullValue = function (ctx) {};

// Enter a parse tree produced by FiltersParser#boolValue.
FiltersListener.prototype.enterBoolValue = function (ctx) {};

// Exit a parse tree produced by FiltersParser#boolValue.
FiltersListener.prototype.exitBoolValue = function (ctx) {};

// Enter a parse tree produced by FiltersParser#regexValue.
FiltersListener.prototype.enterRegexValue = function (ctx) {};

// Exit a parse tree produced by FiltersParser#regexValue.
FiltersListener.prototype.exitRegexValue = function (ctx) {};

// Enter a parse tree produced by FiltersParser#string.
FiltersListener.prototype.enterString = function (ctx) {};

// Exit a parse tree produced by FiltersParser#string.
FiltersListener.prototype.exitString = function (ctx) {};

// Enter a parse tree produced by FiltersParser#literal.
FiltersListener.prototype.enterLiteral = function (ctx) {};

// Exit a parse tree produced by FiltersParser#literal.
FiltersListener.prototype.exitLiteral = function (ctx) {};

// Enter a parse tree produced by FiltersParser#number.
FiltersListener.prototype.enterNumber = function (ctx) {};

// Exit a parse tree produced by FiltersParser#number.
FiltersListener.prototype.exitNumber = function (ctx) {};

// Enter a parse tree produced by FiltersParser#variable.
FiltersListener.prototype.enterVariable = function (ctx) {};

// Exit a parse tree produced by FiltersParser#variable.
FiltersListener.prototype.exitVariable = function (ctx) {};

exports.FiltersListener = FiltersListener;
